import { createMemo } from "solid-js";
import type { HabitRow } from "@habits/shared";
import { useRemindersQuery } from "@habits/shared/solid";

import { HabitFormDialog } from "@/features/habits/components/habit-form-dialog";
import { ShortcutsModal } from "@/components/shortcuts-modal";
import { usePowerSyncContext } from "@/providers/power-sync-context";
import { useDrizzle } from "@/hooks/use-drizzle";
import { useSession } from "@/lib/auth";
import { OFFLINE_CACHE_STALE_TIME_MS } from "@/lib/constants";

interface AppLayoutDialogsProps {
  habitDialogOpen: () => boolean;
  setHabitDialogOpen: (open: boolean) => void;
  editingHabit: () => HabitRow | null;
  nextSortOrder: () => number;
  shortcutsOpen: () => boolean;
  setShortcutsOpen: (open: boolean) => void;
  confirmDeleteOpen: () => boolean;
  setConfirmDeleteOpen: (open: boolean) => void;
}

export function AppLayoutDialogs(props: AppLayoutDialogsProps) {
  const { db } = usePowerSyncContext();
  const drizzle = useDrizzle();
  const session = useSession();

  const reminders = useRemindersQuery({
    db,
    drizzle,
    userId: session.userId,
    staleTime: OFFLINE_CACHE_STALE_TIME_MS,
  });

  const habitReminders = createMemo(() => {
    const habit = props.editingHabit();
    if (!habit) {
      return [];
    }
    return (reminders.data ?? []).filter((r) => r.habit_id === habit.id);
  });

  return (
    <>
      <HabitFormDialog
        open={props.habitDialogOpen()}
        onOpenChange={props.setHabitDialogOpen}
        habit={props.editingHabit()}
        reminders={habitReminders()}
        nextSortOrder={props.nextSortOrder()}
        confirmDeleteOpen={props.confirmDeleteOpen()}
        onConfirmDeleteOpenChange={props.setConfirmDeleteOpen}
      />

      <ShortcutsModal
        isOpen={props.shortcutsOpen()}
        onClose={() => {
          props.setShortcutsOpen(false);
        }}
      />
    </>
  );
}
